<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GGzg8X/tc-custom/9781439665862.jpg?1705766050876" alt="This image is the cover for the book Lost Restaurants of St. Louis"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Restaurants of St. Louis
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A culinary history of the Gateway City and the memorable restaurants that once made their home there.</b></p><p>St. Louis is a food town, and there are many restaurants that have captured the heart of the city. Some of them are no longer around. Rossino’s low ceilings and even lower pipes didn’t stop the pizza-hungry residents from crowding in. Jefferson Avenue Boarding House served elegant “Granny Food” in plush surroundings. King Burgers and onion rings ruled at the Parkmoor. Dohack’s claimed it was the first to name the “jack salmon.” Author Ann Lemons Pollack details these and more restaurants lost to time in the Gateway City.</p><b>“Few St. Louisans know the history of the St. Louis food scene like local food and travel writer Ann Lemons Pollack. . . . The book is a treasure trove for St. Louis history-lovers, beginning with an extensively researched look at the food served at the 1904 Louisiana Purchase Exposition—better known as the 1904 World’s Fair—hosted in St. Louis. She debunks some myths—hot dogs were not “invented” at the fair, but perhaps found a wide audience there—and charts the various restaurants and cafes that fed eager fairgoers.”—<i>Feast Magazine</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Lemons Pollack
      </h2>
      
      <p class="authorDescription body article">Ann Lemons Pollack has been writing about food a good while, but not so long that she remembers all the restaurants in this book. She's reviewed restaurants, written cooking columns, traveled for food and was daring enough to cook for and then marry the restaurant critic of the St. Louis Post-Dispatch, Joe Pollack. Together, they wrote three guidebooks to St. Louis food and many food and travel stories. Ann carries on the tradition and is currently found monthly in and online at St. Louis Magazine and on her blog, stlouiseats.typepad.com, where she also writes about theater.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24d6b140